import React, { useEffect, useRef } from 'react';
import { extractYouTubeVideoId, loadYouTubeIframeApi } from '../../utils/youtubeEmbed.utils';

function YouTubeTimestampPlayer({ videoUrl, onTimeUpdate }) {
  const containerRef = useRef(null);
  const onTimeUpdateRef = useRef(onTimeUpdate);
  onTimeUpdateRef.current = onTimeUpdate;

  useEffect(() => {
    const videoId = extractYouTubeVideoId(videoUrl);
    if (!videoId || !containerRef.current) return undefined;

    let cancelled = false;
    let player = null;
    let timer = null;

    const host = document.createElement('div');
    containerRef.current.replaceChildren(host);

    loadYouTubeIframeApi().then(() => {
      if (cancelled || !window.YT?.Player) return;

      player = new window.YT.Player(host, {
        width: '100%',
        height: '100%',
        videoId,
        playerVars: { controls: 1, playsinline: 1, rel: 0 },
        events: {
          onReady: () => {
            if (cancelled) return;
            // Poll while paused too, so dragging the seek bar updates the timestamp.
            timer = window.setInterval(() => {
              const currentTime = player?.getCurrentTime?.();
              if (Number.isFinite(currentTime)) {
                onTimeUpdateRef.current?.({ currentTime });
              }
            }, 250);
          },
        },
      });
    });

    return () => {
      cancelled = true;
      if (timer) window.clearInterval(timer);
      player?.destroy?.();
    };
  }, [videoUrl]);

  if (!extractYouTubeVideoId(videoUrl)) {
    return <div className="tw-flex tw-items-center tw-justify-center tw-bg-slate-900 tw-text-white">Invalid YouTube video URL.</div>;
  }

  return <div ref={containerRef} className="tw-w-full tw-h-full tw-bg-slate-900" />;
}

export default YouTubeTimestampPlayer;
